// to open tabs in EncounterMenu
export const TabActionEncounterMenu = (data, id, sideNavKey, childActiveId) => {
    return {
        type: 'Open_EncounterMenu_Tab',
        payload: {
            data: data,
            id: id ? id : undefined,
            sideNavKey: sideNavKey,
            childActiveId: childActiveId
        },
    }
}
export const OpenNewEncounterMenuTabAction = (data) => {
    return {
        type: 'Open_New_EncounterMenu_Tab',
        payload: {
            data: data,
        },
    }
}
export const EncounterMenuRecordAction = (Data) => {
    return {
        type: 'EncounterMenuRecordAction',
        payload: Data
    }
}
